export default __webpack_public_path__ + "static/fsk_case_vid-cd7428e4ea3fc08a36064ab7b6293d10.mp4";